import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { EPageType, PageLevelTraffic } from 'shared/models';

const trafficToDeepLinkBuildingProps = (traffic: PageLevelTraffic): DeepLinkBuildingProps => {
  // TODO 404 到 feed
  if (traffic.pageType === EPageType.article) {
    // article not found - active to feed
    if (!traffic.groupId || !traffic.mediaId) {
      return {
        pageType: 'feed',
        categoryId: 0,
      };
    }

    return {
      pageType: 'article',
      groupId: traffic.groupId,
      authorId: traffic.mediaId,
    };
  }

  if (traffic.pageType === EPageType.video) {
    // video not found - active to feed
    if (!traffic.groupId || !traffic.mediaId) {
      return {
        pageType: 'feed',
        categoryId: 0,
      };
    }

    return {
      pageType: 'video',
      groupId: traffic.groupId,
      authorId: traffic.mediaId,
    };
  }

  if (traffic.pageType === EPageType.poi) {
    return {
      pageType: 'poi',
      poiId: traffic.poiId,
    };
  }

  if (traffic.pageType === EPageType.hashtag) {
    return {
      pageType: 'hashtag',
      hashtagId: traffic.hashtagId,
    };
  }

  if (
    traffic.pageType === EPageType.user ||
    traffic.pageType === EPageType.user_follow ||
    traffic.pageType === EPageType.user_topic
  ) {
    return {
      pageType: 'user',
      userId: traffic.userId,
    };
  }

  if (
    traffic.pageType === EPageType.discover ||
    traffic.pageType === EPageType.experience ||
    traffic.pageType === EPageType.experience_article
  ) {
    return {
      pageType: 'search',
      query: traffic.standardKeyword,
    };
  }

  return {
    pageType: 'feed',
    categoryId: 0,
  };
};

export const useActiveToCurrentPage = (): ((
  position: ClickPosition | [ClickPositionPrefix, ClickPosition],
  id?: string,
) => void) => {
  const active = usePageActive();
  const traffic = useAtomValue($PageLevelTraffic);

  return useCallback(
    (position, id) => {
      const enterPosition = Array.isArray(position) ? position[0] + position[1] : position;
      active({
        schemaOption: trafficToDeepLinkBuildingProps(traffic),
        ampExtra: {
          enter_position: enterPosition,
          enter_page_click_id: id || null,
        },
      });
    },
    [traffic],
  );
};
